module.exports = __webpack_public_path__ + "56d755d10baf8f0b8d530ed0f867b0dc.svg";